import { ApiService } from 'services';
import { history } from 'containers/App';

export const GET_LANGUAGE_REQUEST = 'GET_LANGUAGE_REQUEST';
export const GET_LANGUAGE_FAILURE = 'GET_LANGUAGE_FAILURE';
export const GET_LANGUAGE_SUCCESS = 'GET_LANGUAGE_SUCCESS';
export const GET_DEFAULT_LANGUAGE_SUCCESS = 'GET_DEFAULT_LANGUAGE_SUCCESS';

function request() {
  return {
    type: GET_LANGUAGE_REQUEST,
  };
}

function receive(messages) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    locale: messages.locale,
    messages
  };
}

export function getLanguage(locale) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .getLanguage(locale)
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (error.response || (error.retries && error.retries > 1)) {
          if (error.message === 'Network Error') {
            history.push('/no-internet');
          }
          if (!error.response && error.retries && error.retries > 1) {
            ApiService.addQueuedPromise(promise, error);
          }
        }
      });

    return promise();
  };
}
